import {
  BrowserRouter,
  // Route,
  // Routes,
  // Navigate,
  useRoutes,
} from "react-router-dom"
import Header from "@/component/header"
import Footer from "@/component/footer"
import NotFound from "@/pages/notFound"
import Home from "@/pages/home/index"
import Fudu from "@/pages/fudu/index"
import Yikao from "@/pages/yikao/index"
import Jiaoxue from "@/pages/jiaoxue/index"
import Jixun from "@/pages/jixun/index"

const RouteList = () => {
  const routes = [
    {
      path: "/",
      element: <Home />,
    },
    {
      path: "/fudu",
      element: <Fudu />,
    },
    {
      path: "/yikao",
      element: <Yikao />,
    },
    {
      path: "/jiaoxue",
      element: <Jiaoxue />,
    },
    {
      path: "/jixun",
      element: <Jixun />,
    },
    {
      path: "*",
      element: <NotFound />,
    },
  ]

  // routes.forEach((route) => {
  //   route.element = Interceptor(route)
  // });
  // console.log(routes);

  return useRoutes(routes)
}

export default function render() {
  return (
    <div className="page-layout">
      <div className="page-container">
        <BrowserRouter>
          <Header />
          <RouteList />
          <Footer />
        </BrowserRouter>
      </div>
    </div>
  )
}
